import { render, staticRenderFns } from "./IrrFullListComponent.vue?vue&type=template&id=61358ac0"
import script from "./IrrFullListComponent.vue?vue&type=script&lang=js"
export * from "./IrrFullListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports